<template>
  <edit-layout
    @save="handleSave()"
    @cancel="$emit('browsMode')"
    class="sdgs-form"
  >
    2015 年 9 月 25 日，聯合國成立 70
    週年之際，世界領袖們齊聚聯合國紐約總部，舉行「聯合國發展高峰會」，基於千禧年發展目標未能達成的部份，發佈了《翻轉我們的世界：
    2030
    年永續發展方針》。這份方針提出了所有國家都面臨的問題，並基於積極實踐平等與人權，規畫出涵蓋「經濟成長」、「社會進步」與「環境保護」三大面向，共
    17 項永續發展目標及 169 項追蹤指標，作為未來 15 年內（2030
    年以前），成員國跨國合作的指導原則。教育部於2020年出版「永續發展目標（SDGs）教育手冊」，協助學校更加瞭解聯合國推動的永續發展目標，並發展與設計課程，也呼應了
    108 課綱的核心素養理念。
    <p style="color: red">請依據挑戰組別的故事內容挑選一至三項符合的SDGs項目</p>
    <el-form ref="ruleForm">
      <el-form-item>
        <el-checkbox-group v-model="sdgs" :max="3" class="col">
          <el-checkbox v-for="(option, i) in options" :label="option" :key="i"
            >{{ i + 1 }}. {{ option }}</el-checkbox
          >
          <el-checkbox
            v-for="(option, i) in customSdgs"
            :label="option"
            :key="i"
            >{{ option }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
    </el-form>
  </edit-layout>
</template>

<script>
import EditLayout from "./EditLayout.vue";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  components: {
    EditLayout,
  },
  data() {
    return {
      sdgs: [],
      options: [
        "SDG-1 消除貧窮",
        "SDG-2 消除飢餓",
        "SDG-3 良好健康和福祉",
        "SDG-4 優質教育",
        "SDG-5 性別平等",
        "SDG-6 潔淨水與衛生",
        "SDG-7 可負擔的潔淨能源",
        "SDG-8 尊嚴就業與經濟發展",
        "SDG-9 產業創新與基礎設施",
        "SDG-10 減少不平等",
        "SDG-11 永續城市與社區",
        "SDG-12 負責任的消費與生產",
        "SDG-13 氣候行動",
        "SDG-14 水下生命",
        "SDG-15 陸域生命",
        "SDG-16 和平正義與有力的制度",
        "SDG-17 夥伴關係",
      ],
    };
  },
  computed: {
    ...mapState("story", ["editStoryData"]),
    customSdgs() {
      return (this.editStoryData.sdgs || []).filter(
        (sdg) => !this.options.includes(sdg)
      );
    },
  },
  methods: {
    ...mapMutations("story", ["updateEditStoryData"]),
    ...mapActions("story", ["updateStory", "checkProgress"]),
    async handleSave() {
      this.$refs["ruleForm"].validate(async (valid) => {
        // if (valid) {
        // }
      });
      let data = {
        id: this.editStoryData.id,
        sdgs: this.sdgs,
      };
      this.updateEditStoryData(data);
      data.progress = await this.checkProgress();
      await this.updateStory(data);
      this.$emit("browsMode");
      this.$message.success("儲存成功");
    },
  },
  created() {
    this.sdgs = this.editStoryData.sdgs || new Array();
  },
};
</script>
